import emailjs from "emailjs-com";

// Configuración de EmailJS
const EMAILJS_CONFIG = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  userId: process.env.REACT_APP_EMAILJS_USER_ID,
};

// Función para enviar backup por email
export const sendEmailBackup = async (formData, options = {}) => {
  const eventName = options.emailEventName || "Open Door";
  const templateId = options.emailjsTemplateId || EMAILJS_CONFIG.templateId;

  if (!templateId) {
    console.warn("EmailJS: falta template ID (por evento o REACT_APP_EMAILJS_TEMPLATE_ID)");
    return { success: false, error: new Error("EmailJS template ID no configurado") };
  }

  try {
    // Preparar los datos para el template de email
    const emailData = {
      to_email: process.env.REACT_APP_EMAILJS_TO_EMAIL || "info@montironi.com",
      from_name: eventName,
      subject: `Nueva inscripción ${eventName} - ${formData.name}`,

      // Datos del formulario
      nombre: formData.nombre || formData.name,
      apellido: formData.apellido || "",
      dni: formData.dni,
      telefono: formData.phone,
      marca: formData.marcaSeleccionada || "No especificado",
      tipo_formulario: formData.tipoFormulario || "No especificado",
      horario_preferencia: formData.horarioPreferencia || "No especificado",
      estadio_preferencia: formData.estadioPreferencia || "No aplica",
      estadio_direccion: formData.estadioDireccion || "No aplica",
      sede: formData.sede || "No aplica",

      // Metadatos
      ip: formData.ip,
      dispositivo: formData.device,
      origen: formData.origen,
      utm_source: formData.utm_source || "",
      utm_medium: formData.utm_medium || "",
      utm_campaign: formData.utm_campaign || "",
      utm_term: formData.utm_term || "",
      utm_content: formData.utm_content || "",
      fecha: new Date().toLocaleString("es-AR", {
        timeZone: "America/Argentina/Buenos_Aires",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    // Enviar email
    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      templateId,
      emailData,
      EMAILJS_CONFIG.userId
    );

    console.log("Email backup enviado exitosamente:", response);
    return { success: true, response };
  } catch (error) {
    console.error("Error enviando email backup:", error);
    return { success: false, error };
  }
};

// Función para inicializar EmailJS
export const initEmailJS = () => {
  if (EMAILJS_CONFIG.userId) {
    emailjs.init(EMAILJS_CONFIG.userId);
    console.log("EmailJS inicializado correctamente");
  } else {
    console.warn("EmailJS no configurado - faltan variables de entorno");
  }
};

export default emailjs;

